import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { EventsState, FollowSignupState, GetEventsState } from './Types';

import * as Actions from './Actions';
export type EventsAction = ActionType<typeof Actions>;

const initialGetEventsState: GetEventsState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const initialFollowSignupState: FollowSignupState = {
    isCommunicating: false,
    error: false,
};

export default combineReducers<EventsState, EventsAction>({
    getEvents: (state = initialGetEventsState, action) => {
        switch (action.type) {
            case getType(Actions.getEventsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.getEventsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                    data: action.payload,
                };
            case getType(Actions.getEventsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                    data: [],
                };
            default:
                return state;
        }
    },
    followSignup: (state = initialFollowSignupState, action) => {
        switch (action.type) {
            case getType(Actions.followSignupRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    error: false,
                };
            case getType(Actions.followSignupSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.followSignupFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
});
